import { render, staticRenderFns } from "./GFSettlementList.vue?vue&type=template&id=567bd69e"
import script from "./GFSettlementList.vue?vue&type=script&lang=js"
export * from "./GFSettlementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports